import { Box } from '@mui/material';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';

export default function DashboardCard(props: any) {
  return (
    <Card
      style={props.crdStyle}
      sx={{
        display: 'flex',
        borderRadius: "20px",
        transition: "transform 0.3s ease",
        '&:hover': {
          transform: "translateY(-5px)"
        }
      }}
    >
      <Box
        sx={{
          width: 120,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '20px 0 0 20px',
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        }}
      >
        {props.icon}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <CardContent
          sx={{
            flex: '1 0 auto',
            p: 2,
          }}
        >
          <Typography variant="h6">
            {props.title}
          </Typography>
          <Typography variant="subtitle1">
            {props.children}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
}